// src/common/components/cartModal/components/bonusEarnInfo/BonusEarnInfo.tsx
import React, { useMemo } from 'react'
import { MdCardGiftcard } from 'react-icons/md'
import { useTheme } from '../../../../hooks/useTheme'
import styles from './BonusEarnInfo.module.scss'

interface BonusEarnInfoProps {
  earned: number
  percent: number
}

export default function BonusEarnInfo({ earned, percent }: BonusEarnInfoProps) {
  const { theme } = useTheme()

  if (earned === 0) return null

  return (
    <div className={styles.container} style={{ 
      backgroundColor: theme.card,
      borderColor: theme.border 
    }}>
      <div className={styles.icon} style={{ backgroundColor: `${theme.primary}20` }}>
        <MdCardGiftcard size={20} color={theme.onPrimary} />
      </div>
      <div className={styles.content}>
        <span className={styles.title} style={{ color: theme.textSecondary }}>
          Кешбэк за заказ
        </span>
        <div className={styles.valueWrapper}>
          <span className={styles.value} style={{ color: theme.text }}>
            +{earned} ₽
          </span>
          <span className={styles.percent} style={{ color: theme.primary }}>
            {percent}%
          </span>
        </div>
      </div>
    </div>
  )
}